// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__nglfi","question":"Question_question__3LdYj","description":"Question_description__3ysVD"};